import { Component, Vue, Prop } from "vue-property-decorator"

@Component
export default class MatrixComponent extends Vue {
  @Prop({ required: true, type: Array })
  value!: number[]

  @Prop({ required: true, type: Number })
  rows!: number

  @Prop({ required: true, type: Number })
  cols!: number

  @Prop({ default: 0.01 })
  step!: number

  @Prop({ default: false })
  colOneHot!: boolean

  setOneHotCol(jj: number) {
    for (let i = 0; i < this.rows; ++i) {
      for (let j = 0; j < this.cols; ++j) {
        const index = j * this.rows + i
        this.$set(this.value, index, j === jj ? 1 : 0)
      }
    }
  }
}
